import React from 'react';
import { PapiUser, PapiDeviation } from '@wix/da-papi-types';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import PublishedTime from '../../_partials/PublishedTime';
import UserAvatar from '../../../User/Avatar/UserAvatar';
import UserLink from '../../../User/Link/UserLink';
import s from './UserInfoBlock.scss';

interface Props {
  user: PapiUser;
  publishedTime?: string;
  deviation?: PapiDeviation;
}

const UserInfoBlock: React.FC<Props> = ({ user, publishedTime, deviation }) => {
  const landOnGallery = useFlag('land_on_gallery');

  const linkTo = landOnGallery && deviation ? 'gallery' : undefined;
  const deviationIdSeed =
    landOnGallery && deviation ? deviation.deviationId : undefined;
  const anchor = landOnGallery && deviation ? true : undefined;

  return (
    <div className={s['root']}>
      <UserAvatar
        size={32}
        user={user}
        className={s['author-avatar']}
        linkTo={linkTo}
        deviationIdSeed={deviationIdSeed}
        anchor={anchor}
      />
      <span className={s['author-username']}>
        <UserLink
          user={user}
          className={s['author-userlink']}
          linkTo={linkTo}
          deviationIdSeed={deviationIdSeed}
          anchor={anchor}
        />
        {publishedTime && (
          <PublishedTime publishedTime={publishedTime} withoutText />
        )}
      </span>
    </div>
  );
};
UserInfoBlock.displayName = 'UserInfoBlock';

export default UserInfoBlock;
